import React, { Component } from 'react'

class DoctorsInfo extends Component<any, any> {
    render() {
        const { specialization, doctorSpecialities } = this.props
        return (
            <div>
                {specialization && specialization.length > 0 ? (
                    <div>
                        <strong>התמחויות</strong>
                        {specialization.map((spec, index) => (
                            <div key={index}>- {spec.name}</div>
                        ))}
                    </div>
                ) : (
                    <div>
                        <strong>ללא התמחויות</strong>
                    </div>
                )}
                {doctorSpecialities && doctorSpecialities.length > 0 ? (
                    <div>
                        <strong>התמקצעות</strong>
                        {doctorSpecialities.map((spec, index) => (
                            <div key={index}>- {spec.name}</div>
                        ))}
                    </div>
                ) : (
                    <div>
                        <strong>ללא התמקצעות</strong>
                    </div>
                )}
            </div>
        )
    }
}

export default DoctorsInfo
